import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { FiltersItem } from '../../../models/shared/filters-item.model';

@Component({
    selector: 'app-all-communities-filter-checkbox',
    templateUrl: './all-communities-filter-checkbox.component.html',
})
export class AllCommunitiesFilterCheckboxComponent implements OnInit {
    @Output() ready = new EventEmitter();
    @Output() selectionChanged = new EventEmitter();

    @Input() buttonName: string;

    allCommunitiesFilterItem: FiltersItem;

    constructor() {}

    ngOnInit(): void {
        this.allCommunitiesFilterItem = new FiltersItem('isAllCommunitiesChecked', this.buttonName);
        this.resetFilters();
        this.ready.emit();
    }

    onAllCommunitiesSelectionChanged() {
        this.selectionChanged.emit();
    }

    resetFilters(): void {
        this.allCommunitiesFilterItem.uncheck();
    }

    onSelectionChanged() {
        this.selectionChanged.emit();
    }
}
